import { render } from "./dashboardPage.vue?vue&type=template&id=4939ae46"
import script from "./dashboardPage.vue?vue&type=script&lang=js"
export * from "./dashboardPage.vue?vue&type=script&lang=js"

import "./dashboardPage.vue?vue&type=style&index=0&id=4939ae46&lang=css"

import exportComponent from "/Users/yuviony/vspl/ui/vetaconnect_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__